import type { TOC } from '@ember/component/template-only';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

export default <template>
  <div class='field'>
    <@form.Dropdown
      @labelName='Maladie sous-jacente'
      @propertyName='underlyingDisease'
      @translationKey='pathology.underlying-disease'
      @allowAdditions={{true}}
      as |dropdown|
    >
      <dropdown.Item @key='hepatic-fibrosis' />
      <dropdown.Item @key='hepatic-cirrhosis' />
      <dropdown.Item @key='steatosis' />
      <dropdown.Item @key='viral-hepatitis' />
      <dropdown.Item @key='drug-induced-hepatitis' />
      <dropdown.Item @key='fulminant-hepatitis' />
    </@form.Dropdown>
  </div>
</template> satisfies TOC<{
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}>;
